import * as React from 'react';

import NoEntities from '../../shared/NoEntities';

const NoCharacters: React.FunctionComponent = () => {
  return <NoEntities>作成したエピソードがありません</NoEntities>;
};

export default React.memo(NoCharacters);
